import { useCallback, useEffect, useMemo, useState } from 'react';

import { useLocation } from 'react-router';

import { STORAGE_KEYS } from '@/constants';
import { MappingModalContext } from '@/context';
import { APP_ROUTES } from '@/routes';
import { MappingModalProviderProps } from '@/types';

const shouldShowMappingModal = () => {
  const lsMappingModalState = localStorage.getItem(STORAGE_KEYS.MAPPING_MODAL_CLOSED_KEY);

  if (lsMappingModalState === null) {
    localStorage.setItem(STORAGE_KEYS.MAPPING_MODAL_CLOSED_KEY, 'false');
    return true;
  }

  return lsMappingModalState ? lsMappingModalState !== 'true' : false;
};

export const MappingModalProvider = ({ children }: MappingModalProviderProps) => {
  const location = useLocation();

  const [shouldShowModal, setShouldShowModal] = useState(shouldShowMappingModal());

  const showModal = useCallback(() => {
    localStorage.setItem(STORAGE_KEYS.MAPPING_MODAL_CLOSED_KEY, 'false');
    setShouldShowModal(true);
  }, []);

  const hideModalTemporarily = useCallback(() => {
    setShouldShowModal(false);
  }, []);

  const hideModalPermanently = useCallback(() => {
    localStorage.setItem(STORAGE_KEYS.MAPPING_MODAL_CLOSED_KEY, 'true');
    setShouldShowModal(false);
  }, []);

  useEffect(() => {
    if (location.pathname === APP_ROUTES.aires) {
      setShouldShowModal(shouldShowMappingModal());
    }
  }, [location.pathname]);

  const contextValue = useMemo(
    () => ({
      shouldShowModal,
      showModal,
      hideModalTemporarily,
      hideModalPermanently,
    }),
    [shouldShowModal, showModal, hideModalTemporarily, hideModalPermanently],
  );

  return <MappingModalContext.Provider value={contextValue}>{children}</MappingModalContext.Provider>;
};
